import sideImg from "../assets/images/bg-sidebar-desktop.svg";
import plan1 from "../assets/images/icon-arcade.svg";
import plan2 from "../assets/images/icon-advanced.svg";
import plan3 from "../assets/images/icon-pro.svg";
import thanku from "../assets/images/icon-thank-you.svg";
export { sideImg, plan1, plan2, plan3, thanku };
